import { Component, Prop, h, State, Host, Element } from '@stencil/core';
import state from './pn-sidenav-store';
import { angle_small_down, angle_small_up } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-sidenav-link',
  styleUrl: 'pn-sidenav-link.scss',
  shadow: false,
})
export class PnSidenavLink {
  @Element() hostElement: HTMLElement;

  /** Name */
  @Prop() name: string = '';
  /** Href */
  @Prop() href: string = '';
  /** Target */
  @Prop() target: string = null;
  /** Link id */
  @Prop() linkid: string = null;
  /** Icon */
  @Prop() icon: string = '';
  /** Currently selected */
  @Prop() currentSelection: boolean = false;

  /** Level ID that we control toggle on */
  @State() levelId: string = '';
  /** Menu item is open */
  @State() open: boolean = false;
  @State() hasChildren: boolean = false;

  componentWillLoad() {
    this.hasChildren = this.hostElement.querySelectorAll('pn-sidenav-level').length > 0;
    const safeLevelName = this.name.toLowerCase().replace(/\W/gi, '_');
    if (this.hasChildren && this.name) {
      this.levelId = `sidenav-lvl${2}-${safeLevelName}`;
    }
    if (!this.linkid && this.name) {
      this.linkid = `sidenav-link-${safeLevelName}`;
    }
  }
  // onClick={this.setOpenMenuLevel.bind(this)}
  onExpandClick() {
    state.openLevel = state.openLevel + '' === this.levelId + '' ? '' : this.levelId;
  }

  getTagName() {
    return this.href ? 'a' : 'button';
  }

  render() {
    const TagName = this.getTagName();
    const linkAttributes = {
      href: this.href,
      target: this.target,
      id: this.linkid,
      class: 'pn-sidenav-link',
    };

    let buttonAttributes = {
      'aria-controls': this.levelId,
      'aria-label': (this.open ? state.i18n.close : state.i18n.open) + ' ' + this.name,
      'aria-expanded': (state.openLevel + '' === this.levelId + '') + '',
      'onClick': this.onExpandClick.bind(this),
    };

    return (
      <Host role="listitem" name={this.name} href={this.href} linkid={this.linkid} current={this.currentSelection}>
        <TagName {...linkAttributes} {...(TagName === 'button' && { ...buttonAttributes })}>
          {this.icon ? <pn-icon icon={this.icon} color="blue700"></pn-icon> : null}

          <span>{this.name}</span>

          {this.hasChildren && TagName === 'button' ? (
            <div class="pn-sidenav-link-expand">
              {this.open ? (
                <pn-icon class="first-level_icon" icon={angle_small_up} color="blue700" />
              ) : (
                <pn-icon class="first-level_icon" icon={angle_small_down} color="blue700" />
              )}
            </div>
          ) : null}
        </TagName>
        {this.hasChildren && TagName === 'a' ? (
          <button {...buttonAttributes} class="pn-sidenav-link-expand">
            {this.open ? <pn-icon class="first-level_icon" icon={angle_small_up} color="blue700" /> : <pn-icon class="first-level_icon" icon={angle_small_down} color="blue700" />}
          </button>
        ) : null}
        <slot></slot>
      </Host>
    );
  }
}
